import { useEffect, useState } from "react";
import { api, useAuth } from "@/auth/AuthContext";

function usePolled(path, interval, enabled = true) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  useEffect(() => {
    if (!enabled) { setData(null); return; }
    let alive = true;
    const load = () => api.get(path).then(({ data }) => { if (alive) { setData(data); setError(false); } }).catch(() => alive && setError(true));
    load();
    const id = setInterval(load, interval);
    return () => { alive = false; clearInterval(id); };
  }, [path, interval, enabled]);
  return { data, error };
}

export const useOverview = () => usePolled("/markets/overview", 60_000);
export const useNews = () => usePolled("/markets/news", 300_000);
export function useRadar() {
  const { user } = useAuth();
  return usePolled("/markets/radar", 300_000, !!user);
}

export const fmtIN = (n, d = 2) => n == null ? "—" : n.toLocaleString("en-IN", { minimumFractionDigits: d, maximumFractionDigits: d });
export function fmtPct(n) {
  if (n == null) return "—";
  const sign = n > 0 ? "+" : "";
  return `${sign}${n.toFixed(2)}%`;
}
export function dir(n) {
  if (n == null || n === 0) return "flat";
  return n > 0 ? "up" : "down";
}
